// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1882":"353af279","9628":"ffe73276"}[chunkId] + ".chunk.css";
};